
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#C3AFA3"}},[_c('circle',{attrs:{"cx":"7.719","cy":"4.946","r":"1.781"}}),_c('path',{attrs:{"d":"M13.392 6.895a.813.813 0 00-.725-.437.797.797 0 00-.707.464l-1.233 2.719a.197.197 0 01-.334.042l-.65-.81a.792.792 0 00-1.266.039L6.01 12.437a.396.396 0 00.324.626h9.5a.396.396 0 00.354-.573l-2.795-5.595z"}}),_c('path',{attrs:{"d":"M17.417 0H4.354C3.48 0 2.771.709 2.771 1.583v13.063c0 .874.709 1.583 1.583 1.583h13.063c.874 0 1.583-.709 1.583-1.583V1.583C19 .71 18.291 0 17.417 0zm-.115 14.53a.396.396 0 01-.28.116H4.75a.396.396 0 01-.396-.396V1.98c0-.22.177-.397.396-.397h12.27c.22 0 .397.178.397.396V14.25a.396.396 0 01-.115.278v.002z"}}),_c('path',{attrs:{"d":"M15.438 17.417H1.979a.396.396 0 01-.396-.396V3.562a.792.792 0 10-1.583 0v13.855C0 18.29.709 19 1.583 19h13.854a.792.792 0 100-1.583z"}})])])
          )
        }
      }
    